import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { Box } from "../../../../components/Box";
import { useFillViewportHeight } from "../../../../hooks/useFillViewportHeight";
import { Flex } from "../../../../components/Flex";
import CustomTabs from "../../../../components/CustomTabs";
import { Loader } from "../../../../components/Loader";
import { TitleHeading, CardLine } from "../../../IndividualView";
import { useProfileForms } from "../../../../data/useProfileForms";
import { Profile } from "../../../../types/Profile";
import { ProfileForm } from "../../../../types/Forms";
import { FormsByRecord } from "./FormsByRecord";
import { FormsByQuestion } from "./FormsByQuestion";

export const FormsTab = ({
  profile: profileOverride,
}: {
  profile?: Profile;
}) => {
  const { ref: fillRef, height: fillHeight } = useFillViewportHeight();
  const outlet = useOutletContext<{ profile: Profile } | null>();
  const profile = profileOverride ?? outlet?.profile;

  const { data: formsData, isLoading } = useProfileForms(profile?.id);

  const forms: ProfileForm[] = formsData ?? [];

  // Two readings of the same payload: one route through the application per
  // Individual record, or each question's answers changing over time.
  // Default: By application.
  const [viewIndex, setViewIndex] = useState(0);

  return (
    <Box ref={fillRef} height={fillHeight} overflowY="auto" overflowX="hidden">
      <TitleHeading mb={2}>Forms</TitleHeading>

      {isLoading ? (
        <Flex justifyContent="center" alignItems="center" minHeight="20vh">
          <Loader />
        </Flex>
      ) : forms.length ? (
        <CustomTabs
          variant="segmented"
          activeTab={viewIndex}
          onTabChange={setViewIndex}
          tabs={[
            {
              label: "By application",
              content: <FormsByRecord forms={forms} />,
            },
            {
              label: "By question",
              content: <FormsByQuestion forms={forms} />,
            },
          ]}
        />
      ) : (
        <CardLine>
          This section is not included in your application process.
        </CardLine>
      )}
    </Box>
  );
};
